// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2xFPV","header":"MergedInvoice_header__3F6kV"};